import React from 'react';
import { createRoot } from 'react-dom/client';

import App from './App';

/* Rendered, not hydrated.
 *
 * Every public route ships as prerendered HTML (see prerender.js) so that
 * crawlers which do not run JavaScript still get the whole page. That
 * markup is captured by serialising a real DOM, and serialising merges
 * adjacent text nodes: `Call {phone} and talk it through` goes out as one
 * text node where React expects three. Hydration reads that as a content
 * mismatch and discards the tree anyway, with a console full of errors on
 * the way. Rendering over the top is the same amount of work without the
 * pretence.
 *
 * The static HTML has already earned its keep by this point: it is what the
 * crawler indexed, and what the reader was looking at while this bundle
 * downloaded. */
createRoot(document.getElementById('root')).render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
);
